import React, { useState,useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";
import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { DatePicker, Space } from 'antd';
import { Select } from 'antd';
import { Switch } from 'antd';
import moment from "moment";
import Cookie from 'js-cookie';
import { addStore, addStoreInfo } from '../Store/actions//storeService';
import Spinner from '../../UIComponents/Spinner/Spinner';
import MessageBox from '../../UIComponents/MessageBox/MessageBox';
import { getWareHouseList, WareHouseList } from './actions/wareHouseService';
import LZString from 'lz-string';
import dayjs from 'dayjs';


const { Option } = Select;



const  AddWareHouse =()=> {
 const StepList= [
  {
    Style: "inprogress",
    Label: "WareHouse Details",
    Index: 1,
    Icon: "fa fa-building"
  },
  {
    Style: "",
    Label: "Landlord Details",
    Index: 2,
    Icon: "fa fa-user"
  },
  {
    Style: "",
    Label: "Property Details",
    Index: 3,
    Icon: "fa fa-globe"
  },
  {
    Style: "",
    Label: "WareHouse User Details",
    Index: 4,
    Icon: "fa fa-user"
  },
  {
    Style: "",
    Label: "Asset Overview",
    Index: 5,
    Icon: "fa fa-cogs"
  }
  ]
  const navigate = useNavigate();
   const dispatch = useDispatch()
   const jsonData = Cookie.get('currentUser');
             let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
   const user = JSON.parse(decompressedData) 
   const userID = user['userId'];
   const EditStoreError=useSelector(state=>state?.store)
  const StateList = useSelector(state => state?.wareHouse?.WareHouseDetails?.States)
  const ZoneList = useSelector(state => state?.wareHouse?.WareHouseDetails?.Zones)
  const CitiesList = useSelector(state => state?.wareHouse?.WareHouseDetails?.cities)
  const BuildingType = useSelector(state => state?.wareHouse?.WareHouseDetails?.buildingTypes);
  const PropertyTypes = useSelector(state => state?.wareHouse?.WareHouseDetails?.propertyTypes)
  const StoreLeaderList=useSelector(state=>state?.wareHouse?.WareHouseDetails?.StoreManagerList)
  const StoreOperationalList=useSelector(state=>state?.wareHouse?.WareHouseDetails?.StoreOperationalList)
  const ZonalManagerList=useSelector(state=>state?.wareHouse?.WareHouseDetails?.ZonalManagerList)
  const [stepCount, setStepCount] = useState(1);
  const [stepFormList, setStepFormList] = useState(StepList)
  const [buildingType,setBuildingType]=useState("");
  const [storeName,setStoreName]=useState("");
  const [storeCost,setStoreCost]=useState("");
  const [storeImage,setStoreImage]=useState("");
  const [storeImageName,setStoreImageName]=useState("");
  const [storeAddress,setStoreAddress]=useState("");
  const [storeZone,setStoreZone]=useState("");
  const [storeCity,setStoreCity]=useState("");
  const [storeState,setStoreState]=useState("");
  const [storeStaus,setStoreStatus]=useState(true);
  const [landLordName,setLandLordName]=useState("");
  const [landLordEmail,setLandLordEmail]=useState("");
  const [landLordMob,setLandLordMob]=useState("");
  const [landLordAltMob,setLandLordAltMob]=useState("");
  const [leaseStartDate,setLeaseStartDate]=useState(dayjs().format("YYYY-MM-DD"));
  const [leaseEndDate,setLeaseEndDate]=useState(dayjs().format("YYYY-MM-DD"));
  const [storeOpeningDate,setStoreOpeningDate]=useState(dayjs().format("YYYY-MM-DD"));
  const [warrentyDate,setWarrentyDate]=useState(dayjs().format("YYYY-MM-DD"));
  const [salesArea,setSalesArea]=useState("");
  const [buildUpArea,setBuildUpArea]=useState("");
  const [carParking,setCarParking]=useState("");
  const [carParkingNumber,setCarParkingNumber]=useState("");
  const [twoWheelerParkingLot,setTwoWheererParkingLot]=useState("");
  const [NoOfStackParking,setNoOfStackParking]=useState("");
  const [playGround,setPlayground]=useState("");
  const [playGroundSize,setPlaygroundSize]=useState("0");
  const [playGroundTurf,setPlaygroundTurf]=useState("");
  const [playGroundTurfSize,setPlaygroundTurfSize]=useState("0");
  const [storeOpRef,setStoreOpRef]=useState("");
  const [storeOpRefMob,setStoreOpRefMob]=useState("");
  const [storeLeader,setStoreLeader]=useState("");
  const [storeLeaderMob,setStoreLeaderMob]=useState("");
  const [zoneOMCName,setZoneOMCName]=useState("");
  const [zoneOMCMob,setZoneOMCMob]=useState("");
  const [cmName,setCMName]=useState("");
  const [cmMob,setCMMob]=useState("");
  const [maintenanceLeadName,setMaintenanceName]=useState("");
  const [maintenanceLeadMob,setMaintenanceLeadMob]=useState("");
  const [storeMaintenanceImage,setStoreMaintenanceImage]=useState("")
  const [storeMaintenanceFileName,setMaintenanceFileName]=useState("")
  const [isSubmit,setIsSubmit]=useState(false)
  const [gstNumber,setGstNumber] = useState("")
  const [propertyType, setPropertyType] = useState('')
  const _doNavToStoreList = () => {
    dispatch(WareHouseList(true))
  };
  const setSelectedStoreFile=(file)=>{
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () =>{ 
       setStoreImageName(file.name);
        let encoded = setStoreImage(reader.result.toString().replace(/^data:(.*,)?/, ''))
      }
    reader.onerror = error => console.log(error)
  }
  const setSelectedMaintenanceFile=(file)=>{
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () =>{ 
      setMaintenanceFileName(file.name);
      setStoreMaintenanceImage(reader.result.toString().replace(/^data:(.*,)?/, ''))
      }
    reader.onerror = error => console.log(error)
  }
  useEffect(() => {
    setStepFormList(() => _doChangeStep())
  }, [stepCount])

  const validateEmail=(email) =>
  {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
  }
  const _doChangeStep = () => {
    let TempArray = []
    stepFormList.map((element) => {
      if (stepCount > element.Index) {
        element.Style = "completed"
      }
      else if (stepCount == element.Index) {
        element.Style = "inprogress"
      }
      else {
        element.Style = ""
      }
      TempArray.push(element)
    })
    return TempArray;
  }
  const doNextStep=()=>{
    setIsSubmit(true)
    if(storeName.trim()=='' && stepCount==1)return;
    else if((`${storeCost}`.length>10 ||`${storeCost}`.length<10 ) && stepCount==1)return;
    else if(storeAddress.trim()=='' && stepCount==1)return;
    else if(buildingType=='' && stepCount==1)return;
    // else if(storeImage.trim()=='' && stepCount==1)return;
    else if(storeZone=='' && stepCount==1)return;
    else if(storeCity=='' && stepCount==1)return;
    else if(storeState=='' && stepCount==1)return;
    // else if(landLordName.trim()=='' && stepCount==2)return;
    // else if((landLordEmail.trim()=='' || !validateEmail(landLordEmail))  && stepCount==2)return;
    // else if((`${landLordMob}`.length<10 ||`${landLordMob}`.length>10) && stepCount==2)return;
    // else if((landLordAltMob.length>0 &&landLordAltMob.length<10) && stepCount==2)return;
    // // else if((`${landLordAltMob}`.length<10 ||`${landLordAltMob}`.length>10) && stepCount==2)return;
   
    // else if(carParking.trim()=='' && stepCount==3)return;
    // // else if((`${carParkingNumber}`.length==0) && stepCount==3)return;
    // else if(`${twoWheelerParkingLot}`.length==0 && stepCount==3)return;
    // else if(`${NoOfStackParking}`.length==0 && stepCount==3)return;
    // else if(playGround.trim()=='' && stepCount==3)return;
    // else if(`${playGroundSize}`.length==0 && stepCount==3)return;
    // else if(playGroundTurf.trim()=='' && stepCount==3)return;
    // else if(`${playGroundTurfSize}`.length==0 && stepCount==3)return;
    // else if((`${salesArea}`.length==0 ||`${salesArea}`.length>20) && stepCount==3)return
    // else if((`${buildUpArea}`.length==0 ||`${buildUpArea}`.length>20) && stepCount==3)return;
    // else if(storeMaintenanceImage=='' && stepCount==3)return;
    setStepCount(stepCount => stepCount + 1)
    setIsSubmit(false)
  }
 const  selectState=(value)=>{
  setStoreState(value)
  }
  const doSubmit=()=>{
    setIsSubmit(true)
    //  if(storeOpRef=='' && stepCount==4)return;
    // else if((`${storeOpRefMob}`.length>10 || `${storeOpRefMob}`.length<10) && stepCount==4)return;
    // else if(storeLeader=='' && stepCount==4)return;
    // else if((`${storeLeaderMob}`.length>10 || `${storeLeaderMob}`.length<10) && stepCount==4)return;
    // else if(zoneOMCName=='' && stepCount==4)return;
    // else if((`${zoneOMCMob}`.length>10 || `${zoneOMCMob}`.length<10) && stepCount==4)return;
    // else if(maintenanceLeadName=='' && stepCount==4)return;
    // else if((`${maintenanceLeadMob}`.length>10 || `${maintenanceLeadMob}`.length<10) && stepCount==4)return;
    if(storeName.trim()=='' && stepCount==1)return;
    else if((`${storeCost}`.length>10 ||`${storeCost}`.length<10 ) && stepCount==1)return;
    else if(storeAddress.trim()=='' && stepCount==1)return;
    else if(buildingType=='' && stepCount==1)return;
    // else if(storeImage.trim()=='' && stepCount==1)return;
    else if(storeZone=='' && stepCount==1)return;
    else if(storeCity=='' && stepCount==1)return;
    else if(storeState=='' && stepCount==1)return;
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    const userID = user['userId'];

    let data={
      fedid:userID,
      store_id:0,
      store_type_id:101,
      building_type:Number(buildingType),
      property_type:propertyType,
      store_name:storeName,
      file:storeImage,
      filename:storeImageName,
      gst_number:gstNumber,
      store_address:storeAddress,
      store_zone:storeZone,
      store_city:storeCity,
      store_state:Number(storeState),
      store_active:storeStaus?1:0,
      store_costcenter:storeCost,
      landlard_name:landLordName,
      landlard_email:landLordEmail,
      store_notifications:"1",
      landlard_contact_number:landLordMob,
      landlard_alter_contact_number:landLordAltMob,
      landlard_lease_start_date:leaseStartDate,
      landlard_lease_end_date:leaseEndDate,
      landlard_store_opening_date:storeOpeningDate,
      prop_landlard_warranty_end_date:warrentyDate,
      prop_sales_area:salesArea,
      prop_builtup_area:buildUpArea,
      prop_car_parking:carParking,
      prop_number_of_cars_parking:carParkingNumber,
      prop_number_of_two_wheelars_parking:twoWheelerParkingLot,
      prop_number_of_stack_parking:NoOfStackParking,
      prop_playground_concreate:playGround,
      prop_playground_concreate_size:playGroundSize,
      prop_playground_turf:playGroundTurf,
      prop_playground_turf_size:playGroundTurfSize,
      store_operation_referent_employee_id:storeOpRef,
      store_operation_referent_mobile_number:storeOpRefMob,
      store_sm_employee_id: storeLeader,
      store_sm_mobile_number: storeLeaderMob,
      store_zomc_employee_id:zoneOMCName,
      store_zomc_mobile_number:zoneOMCMob,
      store_cm_employee_id:cmName,
      store_cm_mobile_number:cmMob,
      store_maintaince_lead_employee_id:maintenanceLeadName,
      store_maintaince_lead_mobile_number:maintenanceLeadMob,
      maintainencechecklistonename:storeMaintenanceFileName,
      maintainencechecklistone:storeMaintenanceImage,
      maintainencechecklisttwo:"",
      maintainencechecklisttwoname:""
    }
   
   dispatch(addStoreInfo(data))
  }
    return (
      <div className="wrapper">
        <Header title={"Create New WareHouse"} />
        <Menu1 />
        {EditStoreError.modalOpen ? (
          <MessageBox
            message={EditStoreError.message}
            // signout={"false"}
            onClose={()=> {
              dispatch(WareHouseList(true))
              dispatch(getWareHouseList(userID, '101'))
            }
            }
          />
          
        ) : null}
  {EditStoreError.loading ? (
              <Spinner />
            ) : (
        <div className='content-wrapper'>
          <section className='content top-space'>
            <div className="m-panel">
              <div className="m-panel__body pb-10">
                <div className="m-step-form">
                  <div className="m-step-form__container">
                    <div className="m-step-form__list">
                      {
                        stepFormList.map((item =>
                          <div className={"m-step-form__item " + item.Style} key={item.Index}>
                            <div className="m-step-form__item--box">
                              <span className={item.Icon}></span>
                            </div>
                            <h5 className="m-step-form__item--lbl">{item.Label}</h5>
                          </div>
                        ))
                      }
                    </div>
                    <div className="m-step-form__content">
                      {
                        stepCount === 1 ?
                          <div className="row m-grid">
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Building type*</label>
                                <Select className="form-control"
                                showSearch
                                placeholder="-- Please Select --"
                                onChange={(value)=>setBuildingType(value)}
                                value={buildingType}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                              > {
                                BuildingType?.map?.((item,i) =>

                                <Option key={i} value={item.id}>{item.value}</Option>
                                  )
                                }
                              </Select>
                              {buildingType=='' && isSubmit==true?<span className="text-danger">Please Select Building Type</span>:null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Property type*</label>
                                <Select className="form-control"
                                  showSearch
                                  placeholder="-- Please Select --"
                                  onChange={(value) => setPropertyType(value)}
                                  value={propertyType}
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > {
                                    PropertyTypes?.map?.((item, i) =>

                                      <Option key={i} value={item.id}>{item.value}</Option>
                                    )
                                  }
                                </Select>
                                {propertyType == '' && isSubmit == true ? <span className="text-danger">Please Select Property Type</span> : null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>WareHouse name*</label>
                                <input type="text" maxLength="100" value={storeName} onChange={(e)=>setStoreName(e.target.value.replace(/[^\w\s]/gi, ""))} className="form-control" />
                                {storeName.trim()=='' && isSubmit==true?<span className="text-danger">Please Enter WareHouse Name</span>:null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>WareHouse cost center*</label>
                                <input type="text" maxLength="10" value={storeCost} onChange={(e)=>setStoreCost(e.target.value.replace(/[^\w\s]/gi, ""))} className="form-control" />
                                {(`${storeCost}`.length>10 ||`${storeCost}`.length<10 ) && isSubmit==true?<span className="text-danger">Please Enter WareHouse Cost Center</span>:null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>GST number*</label>
                                <input type="text" maxLength="100" value={gstNumber} onChange={(e) => setGstNumber(e.target.value.replace(/[^\w\s]/gi, ""))} className="form-control" />
                                {gstNumber.trim() == '' && isSubmit == true ? <span className="text-danger">Please Enter GST number</span> : null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>WareHouse image</label>
                                <input type="file" className="form-control" onChange={(e) => setSelectedStoreFile(e.target.files[0])} accept={".png, .jpg, .jpeg"}/>
                                {/* {storeImage.trim()=='' && isSubmit==true? <span className="text-danger">Please Select WareHouse Image</span>:null} */}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>WareHouse address*</label>
                                <input type="text" maxLength="100" className="form-control"  value={storeAddress} onChange={(e)=>setStoreAddress(e.target.value.replace(/[^\w\s]/gi, ""))} />
                                {storeAddress.trim()=='' && isSubmit==true ?<span className="text-danger">Please Enter WareHouse Address</span>:null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Zone*</label>
                                <Select className="form-control"
                                  showSearch
                                  onChange={(value)=>setStoreZone(value)}
                                  value={storeZone}
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                >  {
                                  ZoneList?.map((item =>
                                    <Option key={item.value} value={item.id}>{item.value}</Option>
                                  ))
                                }
                                </Select>
                                {storeZone=='' && isSubmit==true ?<span className="text-danger">Please Select Zone</span>:null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>State*</label>
                                <Select className="form-control"
                                  showSearch
                                  onChange={selectState}
                                  value={storeState}
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > {
                                  StateList?.map((item =>
                                      <Option key={item.id} value={item.id}>{item.value}</Option>
                                    ))
                                  }
                                </Select>
                                {storeState=='' && isSubmit==true?<span className="text-danger">Please Select State</span>:null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>City*</label>
                                <Select className="form-control"
                                  showSearch
                                  onChange={(value)=>setStoreCity(value)}
                                  value={storeCity}
                                  placeholder="-- Please Select --"
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                  }
                                > {
                                  CitiesList?.map((item =>
                                    <Option key={item.id} value={item.id}>{item.value}</Option>
                                  ))
                                }
                                </Select>
                                {storeCity=='' && isSubmit==true  && stepCount==1?<span className="text-danger">Please Select City</span>:null}
                              </div>
                            </div>
                            
                            {/* <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Property type*</label>
                                <select className="form-control m-form__input">
                                  <option>-- Please Select --</option>
                                  <option>Own</option>
                                  <option>Lease</option>
                                </select>
                              </div>
                            </div> */}
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>WareHouse status*</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No" defaultChecked onChange={(status)=>setStoreStatus(status)}  />
                              </div>
                            </div>
                          </div>
                          : ""
                      }
                      {
                        stepCount === 2 ?
                          <div className="row m-grid">
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Landlord name*</label>
                                <input type="text" maxLength="100" className="form-control"  value={landLordName} onChange={(e)=>setLandLordName(e.target.value.replace(/[^\w\s]/gi, ""))} />
                                {landLordName.trim()=='' && isSubmit==true?<span className="text-danger">Please Enter Landlord Name</span>:null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Email ID*</label>
                                <input type="text" maxLength="100" className="form-control"  value={landLordEmail} onChange={(e)=>setLandLordEmail(e.target.value.replace(/[^a-zA-Z0-9_@. ]/gi,""))} />
                                {(landLordEmail.trim()=='' || !validateEmail(landLordEmail)) && isSubmit==true?<span className="text-danger">Please Enter Valid Email ID</span>:null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Contact number*</label>
                                <input type="text" maxLength="10" className="form-control"  value={landLordMob} onChange={(e)=>setLandLordMob(e.target.value.replace(/[^0-9]/g,''))} />
                                {(`${landLordMob}`.length<10 ||`${landLordMob}`.length>10 )&& isSubmit==true?<span className="text-danger">Please Enter Valid Mobile Number</span>:null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Alternate number*</label>
                                <input type="text" maxLength="10" className="form-control"  value={landLordAltMob} onChange={(e)=>setLandLordAltMob(e.target.value.replace(/[^0-9]/g,''))} />
                                {(landLordAltMob.length >0&&landLordAltMob.length <10) && isSubmit == true ?<span className="text-danger">Please Enter Valid Mobile Number</span>:null }
                                {/* {(`${landLordAltMob}`.length<10 ||`${landLordAltMob}`.length>10) && isSubmit==true?<span className="text-danger">Please Enter Valid Mobile Number</span>:null} */}
                              </div>
                            </div>
                            { propertyType !=="OWN" &&
                              <>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Lease start date*</label>
                                <DatePicker className="form-control" defaultValue={dayjs(leaseStartDate)} format={'YYYY-MM-DD'}  onChange={(date, dateString) => setLeaseStartDate(dateString)} />
                                {leaseStartDate=='' && isSubmit==true?<span className="text-danger">Please Select Date</span>:null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Lease end date*</label>
                                <DatePicker className="form-control" defaultValue={dayjs(leaseEndDate)} format={'YYYY-MM-DD'}  onChange={(date, dateString) => setLeaseEndDate(dateString)} />
                                {leaseEndDate=='' && isSubmit==true?<span className="text-danger">Please Select Date</span>:null}
                              </div>
                            </div>
                              
                              </>
                            }
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>WareHouse opening date*</label>
                                <DatePicker className="form-control" defaultValue={dayjs(storeOpeningDate)} format={'YYYY-MM-DD'}  onChange={(date, dateString) => setStoreOpeningDate(dateString)} />
                                {storeOpeningDate=='' && isSubmit==true?<span className="text-danger">Please Select Date</span>:null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Warrenty/DLP end date*</label>
                                <DatePicker className="form-control" defaultValue={dayjs(warrentyDate)} format={'YYYY-MM-DD'}  onChange={(date, dateString) => setWarrentyDate(dateString)} />
                                {warrentyDate=='' && isSubmit==true?<span className="text-danger">Please Select Date</span>:null}
                              </div>
                            </div>
                          </div>
                          : ""
                      }

                      {
                        stepCount === 3 ?
                          <div className="row m-grid">
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Sales area(In sqm)*</label>
                                <input type="number" className="form-control"  value={salesArea} onChange={(e)=>setSalesArea(e.target.value)} />
                                {`${salesArea}`.length==0  && isSubmit==true ?<span className="text-danger">Please Enter Sales Area</span>:null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Build up area (In sqm)*</label>
                                <input type="number" className="form-control"  value={buildUpArea} onChange={(e)=>setBuildUpArea(e.target.value)} />
                                {`${buildUpArea}`.length==0  && isSubmit==true?<span className="text-danger">Please Enter Build Up Area</span>:null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Car parking*</label>
                                <select className="form-control m-form__input" value={carParking} onChange={(e) => setCarParking(e.target.value)}>
                                  <option>-- Please Select --</option>
                                  <option value='Yes'>Yes</option>
                                  <option value='No'>No</option>
                                </select>
                                {carParking.trim()=='' && isSubmit==true?<span className="text-danger">Please Enter Car Parking Details</span>:null}
                              </div>
                            </div>
                            {/* {
                              CarParking === "yes" ?
                                <div className="col-md-4">
                                  <div className="form-group">
                                    <label htmlFor='exampleInput'>Select Separate/Combined*</label>
                                    <select className="form-control m-form__input">
                                      <option>-- Please Select --</option>
                                      <option>Separate</option>
                                      <option>Combined</option>
                                    </select>
                                  </div>
                                </div>
                                : ""
                            } */}
                            {carParking == 'Yes' ? <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Car parking number*</label>
                                <input type="number" className="form-control" value={carParkingNumber} onChange={(e) => setCarParkingNumber(e.target.value)} />
                                {/* {`${carParkingNumber}`.length == 0 && isSubmit == true ? <span className="text-danger">Please Enter Car Parking Number</span> : null} */}
                              </div>
                            </div> : null}

                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>No. of two-wheeler parking lots*</label>
                                <input type="number" className="form-control" value={twoWheelerParkingLot} onChange={(e)=>setTwoWheererParkingLot(e.target.value)} />
                                {`${twoWheelerParkingLot}`.length==0 && isSubmit==true?<span className="text-danger">Please Enter Number of Two-Wheeler Parking Lot</span>:null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>No. of stack parking*</label>
                                <input type="number" className="form-control" value={NoOfStackParking} onChange={(e)=>setNoOfStackParking(e.target.value)} />
                                {`${NoOfStackParking}`.length==0 && isSubmit==true?<span className="text-danger">Please Enter Number of Stack Parking</span>:null}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'> Playground Concrete*</label>
                                {/* <input type="text" className="form-control" value={playGround} onChange={(e)=>setPlayground(e.target.value)} /> */}
                                <select className="form-control m-form__input" value={playGround} onChange={(e)=>setPlayground(e.target.value)}>
                                    <option>-- Please Select --</option>
                                    <option value='Yes'>Yes</option>
                                    <option value='No'>No</option>
                                  </select>
                                {playGround.trim()=='' && isSubmit==true?<span className="text-danger">Please Enter PlayGround Details</span>:null}
                              </div>
                            </div>
                            {playGround=='Yes'?<div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Size (In Sqm)*</label>
                                <input type="number" className="form-control" value={playGroundSize} onChange={(e) => setPlaygroundSize(e.target.value)} />
                                {`${playGroundSize}`.length == 0 && isSubmit == true ? <span className="text-danger">Please Enter PlayGround Size</span> : null}
                              </div>
                            </div>:null}
                            <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>PlayGround (Turf)*</label>
                                {/* <input type="text" className="form-control" value={playGroundTurf} onChange={(e)=>setPlaygroundTurf(e.target.value)} /> */}
                                <select className="form-control m-form__input" value={playGroundTurf} onChange={(e)=>setPlaygroundTurf(e.target.value)}>
                                    <option>-- Please Select --</option>
                                    <option value='Yes'>Yes</option>
                                    <option value='No'>No</option>
                              </select>
                                {playGroundTurf.trim()=='' && isSubmit==true?<span className="text-danger">Please Enter PlayGround Turf Details</span>:null}
                              </div>
                            </div>
                            {playGroundTurf=='Yes'? <div className="col-md-4">
                              <div className="form-group">
                                <label htmlFor='exampleInput'>Size (Sqm)*</label>
                                <input type="number" className="form-control" value={playGroundTurfSize} onChange={(e) => setPlaygroundTurfSize(e.target.value)} />
                                {`${playGroundTurfSize}`.length == 0 && isSubmit == true ? <span className="text-danger">Please Enter PlayGround Turf Size</span> : null}
                              </div>
                            </div>:null}
                            <div className="col-md-4">
                            <div className="form-group">
                              <label htmlFor='exampleInput'>Maintenance Split List*</label>
                              <input  type="file" className="form-control" onChange={(e) => setSelectedMaintenanceFile(e.target.files[0])} accept={".xls, .xlsx"}/>
                              {storeMaintenanceImage.trim()=='' && isSubmit==true?<span className="text-danger">Please Select  File</span>:null}
                            
                            </div>
                          </div>
                          </div>
                          : ""
                      }
                      {
                        stepCount === 4 ?
                        <div className="row m-grid">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Store operations Referent*</label>
                            <Select className="form-control"
                              showSearch
                              onChange={(value)=>setStoreOpRef(value)}
                              placeholder="-- Please Select --"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }
                              value={storeOpRef}
                            > {
                              StoreOperationalList?.map((item =>
                                  <Option key={item.employee_id} value={item.employee_id}>{item.fullname}</Option>
                                ))
                              }
                            </Select> 
                            {storeOpRef=='' && isSubmit==true && stepCount==4?<span className="text-danger">Please Select WareHouse Operations Referent</span>:null}
                             </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>WOR mobile number*</label>
                            <input type="text" maxLength="10" className="form-control" value={storeOpRefMob} onChange={(e)=>setStoreOpRefMob(e.target.value.replace(/[^0-9]/g,''))} />
                            {(`${storeOpRefMob}`.length>10 || `${storeOpRefMob}`.length<10) && isSubmit==true?<span className="text-danger">Please Enter Valid Mobile Number</span>:null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>WareHouse leader*</label>
                            <Select className="form-control"
                              showSearch
                              onChange={(value)=>setStoreLeader(value)}
                              placeholder="-- Please Select --"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }
                              value={storeLeader}
                            > {
                              StoreLeaderList?.map((item =>
                                  <Option key={item.employee_id} value={item.employee_id}>{item.fullname}</Option>
                                ))
                              }
                            </Select>
                            {storeLeader=='' && isSubmit==true?<span className="text-danger">Please Select WareHouse Leader</span>:null}
                            </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Store leader mobile number*</label>
                            <input type="text" maxLength="10" className="form-control" value={storeLeaderMob} onChange={(e)=>setStoreLeaderMob(e.target.value.replace(/[^0-9]/g,''))} />
                            {(`${storeLeaderMob}`.length>10 || `${storeLeaderMob}`.length<10) && isSubmit==true?<span className="text-danger">Please Enter Valid Mobile Number</span>:null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Zone operation maintenance coach name*</label>
                            <Select className="form-control"
                              showSearch
                              onChange={(value)=>setZoneOMCName(value)}
                              placeholder="-- Please Select --"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }
                              value={zoneOMCName}
                            > {
                              ZonalManagerList?.map((item =>
                                  <Option key={item.employee_id} value={item.employee_id}>{item.fullname}</Option>
                                ))
                              }
                            </Select>  
                            {zoneOMCName=='' && isSubmit==true?<span className="text-danger">Please Select Zone Operation Coach Name</span>:null}     
                             </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>ZOMC  mobile number*</label>
                            <input type="text" maxLength="10" className="form-control" value={zoneOMCMob} onChange={(e)=>setZoneOMCMob(e.target.value.replace(/[^0-9]/g,''))} />
                            {(`${zoneOMCMob}`.length>10 || `${zoneOMCMob}`.length<10) && isSubmit==true?<span className="text-danger">Please Enter Valid Mobile Number</span>:null}
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Construction manager name*</label>
                            <Select className="form-control"
                              showSearch
                              onChange={(value)=>setCMName(value)}
                              placeholder="-- Please Select --"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }
                              value={cmName}
                            > {
                              StoreOperationalList?.map((item =>
                                  <Option key={item.employee_id} value={item.employee_id}>{item.fullname}</Option>
                                ))
                              }
                            </Select>  
                            {cmName=='' && isSubmit==true?<span className="text-danger">Please Select Construction Manager Name</span>:null}         
                            </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Construction manager mobile number*</label>
                            <input type="text" maxLength="10" className="form-control" value={cmMob} onChange={(e)=>setCMMob(e.target.value.replace(/[^0-9]/g,''))} />
                            {(`${cmMob}`.length>10 || `${cmMob}`.length<10) && isSubmit==true?<span className="text-danger">Please Enter Valid Mobile Number</span>:null}
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Maintance leader name*</label>
                            {/* <input type="text" className="form-control" value={maintainceLeader} onChange={(e)=>setMaintainceLeader(e.target.value)} /> */}
                            <Select className="form-control"
                              showSearch
                              onChange={(value)=>setMaintenanceName(value)}
                              placeholder="-- Please Select --"
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }
                              value={maintenanceLeadName}
                            > {
                              StoreOperationalList?.map((item =>
                                  <Option key={item.employee_id} value={item.employee_id}>{item.fullname}</Option>
                                ))
                              }
                            </Select>
                            {maintenanceLeadName=='' && isSubmit==true ?<span className="text-danger">Please Select Maintance Leader Name</span>:null}          
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor='exampleInput'>Maintance leader mobile number*</label>
                            <input type="text" maxLength="10" className="form-control" value={maintenanceLeadMob} onChange={(e)=>setMaintenanceLeadMob(e.target.value.replace(/[^0-9]/g,''))} />
                            {(`${maintenanceLeadMob}`.length>10 || `${maintenanceLeadMob}`.length<10) && isSubmit==true ?<span className="text-danger">Please Enter Valid Mobile Number</span>:null}
                          </div>
                        </div>
                      </div>
                      : ""
                      }
                      {
                        stepCount === 5 ?
                          <div className="row m-grid">
                            <div className="col-md-12">
                              <h5 className="m-panel__subtitle">Electrical high power</h5>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Transformer</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>UPS</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Lightning system</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Electrical room</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>UPS room</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Power generator</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Dry air circulators</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"/>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Air washers</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Air conditioning system</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No" />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>HVLS fans</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No" />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Air extraction fan</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Roller shutters</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No" />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Metallic doors</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No" />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Fire retardant doors</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Fire doors(Only warehouse)</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Metallic mesh doors</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No" />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>PEB & Roofing</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"/>
                              </div>
                            </div>
                            <div className="col-md-12">
                              <h5 className="m-panel__subtitle">Electrical Low Power</h5>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Fire alarm panel</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Burglar alarm panel</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>PAS (Public announcement system)</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>CCTV camera</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Fire hose reels</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Sprinkler system</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>External hydrant</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Internal hydrant</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Jockey pump</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Diesel pump</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Fire extinguishers</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Lift</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Freigth elevators</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>Escalators</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label>STP (Sewage treatment plant)</label>
                                <Switch checkedChildren="Yes" unCheckedChildren="No"  />
                              </div>
                            </div>
                          </div>
                          : ""
                      }
                      <div className="row">
                        <div className="col-md-12 text-right">
                          <div className="m-page__button top-space">
                            {
                              stepCount > 1 ?
                                <button type='button' onClick={()=>  setStepCount(stepCount => stepCount - 1)} className='btn muted-button  deca-btn-orange'>Prev</button>
                                : ""
                            }
                            {
                              stepCount < 4 ?
                                <button type='button' onClick={()=> doNextStep()} className='btn btn-secondary deca-btn-yellow'>Next</button>
                                : ""
                            }
                              <button type='button' className='btn muted-button  deca-btn-yellow' onClick={()=>doSubmit()}>Submit</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 text-right">
                <div className="m-page__button top-space">
                  <button type='button' onClick={_doNavToStoreList} className='btn muted-button  deca-btn-orange'>Back</button>
                </div>
              </div>
            </div>
          </section>
        </div>)}
        <Footer />
      </div>
    )
}

export default AddWareHouse;